import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Select } from '@folio/stripes-components';
import css from './FontSizeSelector.css';

const FONT_SIZE_KEY = 'folio-user-font-size-preference';

const fontSizeOptions = {
  small: { scale: 0.875, label: 'stripes-core.fontSize.small' },
  medium: { scale: 1.0, label: 'stripes-core.fontSize.medium' },
  large: { scale: 1.125, label: 'stripes-core.fontSize.large' },
  xlarge: { scale: 1.25, label: 'stripes-core.fontSize.xlarge' }
};

const FontSizeSelector = () => {
  const [currentSize, setCurrentSize] = useState('small');

  useEffect(() => {
    const saved = localStorage.getItem(FONT_SIZE_KEY);
    if (saved && fontSizeOptions[saved]) {
      setCurrentSize(saved);
    }
  }, []);

  const applyFontSize = (size) => {
    const scale = fontSizeOptions[size].scale;
    document.documentElement.style.fontSize = `${scale * 100}%`;
  };

  const handleSizeChange = (e) => {
    const size = e.target.value;
    setCurrentSize(size);
    applyFontSize(size);
    localStorage.setItem(FONT_SIZE_KEY, size);
    /** kware start edit - Dispatch custom event to notify ResizeContainer to recalculate widths */
    window.dispatchEvent(new CustomEvent('fontSizeChanged'));
    /** kware end edit */
  };

  return (
    <div className={css.fontSizeSelector}>
      <Select
        label={<FormattedMessage id="stripes-core.fontSize.label" />}
        value={currentSize}
        onChange={handleSizeChange}
        dataOptions={Object.keys(fontSizeOptions).map((key) => ({
          value: key,
          label: <FormattedMessage id={fontSizeOptions[key].label} />
        }))}
      />
    </div>
  );
};

export default FontSizeSelector;
